import * as actionTypes from '../constants/action.types'
import actionCreator from '../utils/actions/creator'

export const initializeApplication = actionCreator(
  actionTypes.INITIALIZE_APPLICATION,
  ({ user, siteKey }) => ({
    user,
    siteKey
  })
)
